import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutObjectionList } from "./autogen/AutogenLayoutObjectionList";

export class ObjectionList extends AutogenLayoutObjectionList {
    onLoad(): void | Promise<void> {
        this.tableObjections.addButtonCaption = "Add Objection";       
    }

    sourceObjectionBeforeExecution(event: DataSourceExecutionEvent): void | Promise<void> {
        event.filter.type_of = "C";
    }
}